import React from 'react'
import propTypes from 'prop-types'

const Divider = ({ type, offset, thickness = 1 }) => {
  const typeClass = (t) => {
    let type
    switch (t) {
      case 'vertical':
        type = { width: thickness }
        break
      case 'horizontal':
        type = { height: thickness }
        break
    }
    return type
  }

  const typeSpacing = {
    vertical: {
      marginTop: `${offset}px`,
      marginBottom: `${offset}px`,
    },
    horizontal: {
      marginLeft: `${offset}px`,
      marginRight: `${offset}px`,
    },
  }

  return (
    <div
      className='divider'
      style={{ ...typeSpacing[type], ...typeClass(type) }}></div>
  )
}

Divider.propTypes = {
  type: propTypes.string.isRequired,
  offset: propTypes.number,
  thickness: propTypes.number,
}

export default Divider
